// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__ah8Pj","labelWrapper":"Tag_labelWrapper__b_yd4","label":"Tag_label__qgikS","labelTruncated":"Tag_labelTruncated__12nll","description":"Tag_description__bbZve"};